export default {
  lang: 'cs',
  dir: 'ltr',
  common: {
    ok: 'Uložit',
    cancel: 'Storno',
    key_backspace: 'backspace',
    key_del: 'delete',
    key_down: 'šipka dolů',
    key_up: 'šipka nahoru',
    more_opts: 'More Options',
    url: 'URL',
    width: 'Width',
    height: 'Height'
  },
  misc: {
    powered_by: 'Běží na'
  },
  ui: {
    toggle_stroke_tools: 'Zobrazit/schovat více možností',
    palette_info: 'Kliknutím změníte barvu výplně, kliknutím současně s klávesou shift změníte barvu čáry',
    zoom_level: 'Změna přiblížení',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Změnit ID elementu',
    fill_color: 'Změnit barvu výplně',
    stroke_color: 'Změnit barvu čáry',
    stroke_style: 'Změnit styl čáry',
    stroke_width: 'Změnit šířku čáry',
    pos_x: 'Změnit souřadnici X',
    pos_y: 'Změnit souřadnici Y',
    linecap_butt: 'Konec úsečky: přesný',
    linecap_round: 'Konec úsečky: zaoblený',
    linecap_square: 'Konec úsečky: s čtvercovým přesahem',
    linejoin_bevel: 'Styl napojení úseček: zkosené',
    linejoin_miter: 'Styl napojení úseček: ostré',
    linejoin_round: 'Styl napojení úseček: oblé',
    angle: 'Změnit úhel natočení',
    blur: 'Změnit rozostření',
    opacity: 'Změnit průhlednost objektů',
    circle_cx: 'Změnit souřadnici X středu kružnice',
    circle_cy: 'Změnit souřadnici Y středu kružnice',
    circle_r: 'Změnit poloměr kružnice',
    ellipse_cx: 'Změnit souřadnici X středu elipsy',
    ellipse_cy: 'Změnit souřadnici Y středu elipsy',
    ellipse_rx: 'Změnit poloměr X elipsy',
    ellipse_ry: 'Změnit poloměr Y elipsy',
    line_x1: 'Změnit počáteční souřadnici X úsečky',
    line_x2: 'Změnit koncovou souřadnici X úsečky',
    line_y1: 'Změnit počáteční souřadnici Y úsečky',
    line_y2: 'Změnit koncovou souřadnici X úsečky',
    rect_height: 'Změnit výšku obdélníku',
    rect_width: 'Změnit šířku obdélníku',
    corner_radius: 'Změnit zaoblení obdélníku',
    image_width: 'Změnit šířku dokumentu',
    image_height: 'Změnit výšku dokumentu',
    image_url: 'Změnit adresu URL',
    node_x: 'Změnit souřadnici X uzlu',
    node_y: 'Změnit souřadnici Y uzlu',
    seg_type: 'Změnit typ segmentu',
    straight_segments: 'úsečka',
    curve_segments: 'křivka',
    text_contents: 'Změnit text',
    font_family_label: 'Font:',
    font_family: 'Změnit font',
    font_size: 'Změnit velikost písma',
    bold: 'Tučně',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Kurzíva',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Hlavní menu',
    bkgnd_color_opac: 'Změnit barvu a průhlednost pozadí',
    connector_no_arrow: 'Bez šipky',
    fitToContent: 'přizpůsobit obsahu',
    fit_to_all: 'Přizpůsobit veškerému obsahu',
    fit_to_canvas: 'Přizpůsobit stránce',
    fit_to_layer_content: 'Přizpůsobit obsahu vrstvy',
    fit_to_sel: 'Přizpůsobit výběru',
    align_relative_to: 'Zarovnat relativně',
    relativeTo: 'relatativně k:',
    page: 'stránce',
    largest_object: 'největšímu objektu',
    selected_objects: 'zvoleným objektům',
    smallest_object: 'nejmenšímu objektu',
    new_doc: 'Nový dokument',
    open_doc: 'Otevřít dokument',
    export_img: 'Export',
    save_doc: 'Uložit dokument',
    import_doc: 'Importovat SVG',
    align_to_page: 'Zarovnat element na stránku',
    align_bottom: 'Zarovnat dolů',
    align_center: 'Zarovnat nastřed',
    align_left: 'Zarovnat doleva',
    align_middle: 'Zarovnat nastřed',
    align_right: 'Zarovnat doprava',
    align_top: 'Zarovnat nahoru',
    mode_select: 'Výběr a transformace objektů',
    mode_fhpath: 'Kresba od ruky',
    mode_line: 'Úsečka',
    mode_rect: 'Rectangle Tool',
    mode_square: 'Square Tool',
    mode_fhrect: 'Obdélník volnou rukou',
    mode_ellipse: 'Elipsa',
    mode_circle: 'Kružnice',
    mode_fhellipse: 'Elipsa volnou rukou',
    mode_path: 'Křivka',
    mode_text: 'Text',
    mode_image: 'Obrázek',
    mode_zoom: 'Přiblížení',
    no_embed: 'POZOR: Obrázek nelze uložit s dokumentem. Bude zobrazován z adresáře, kde se nyní nachází.',
    undo: 'Zpět',
    redo: 'Znovu',
    tool_source: 'Upravovat SVG kód',
    wireframe_mode: 'Zobrazit jen kostru',
    clone: 'Clone Element(s)',
    del: 'Delete Element(s)',
    group_elements: 'Seskupit objekty',
    make_link: 'Make (hyper)link',
    set_link_url: 'Set link URL (leave empty to remove)',
    to_path: 'Objekt na křivku',
    reorient_path: 'Změna orientace křivky',
    ungroup: 'Zrušit seskupení',
    docprops: 'Vlastnosti dokumentu',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Vrstvu úplně dospodu',
    move_top: 'Vrstvu úplně nahoru',
    node_clone: 'Vložit nový uzel',
    node_delete: 'Ostranit uzel',
    node_link: 'Provázat ovládací body uzlu',
    add_subpath: 'Přidat další součást křivky',
    openclose_path: 'Otevřít/zavřít součást křivky',
    source_save: 'Uložit',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    paste_in_place: 'Paste in Place',
    delete: 'Delete',
    group: 'Group',
    move_front: 'Bring to Front',
    move_up: 'Bring Forward',
    move_down: 'Send Backward',
    move_back: 'Send to Back',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Vrstva',
    layers: 'Layers',
    del: 'Odstranit vrstvu',
    move_down: 'Přesunout vrstvu níž',
    new: 'Přidat vrstvu',
    rename: 'Přejmenovat vrstvu',
    move_up: 'Přesunout vrstvu výš',
    dupe: 'Duplicate Layer',
    merge_down: 'Merge Down',
    merge_all: 'Merge All',
    move_elems_to: 'Přesunout objekty do:',
    move_selected: 'Přesunout objekty do jiné vrstvy'
  },
  config: {
    image_props: 'Vlastnosti dokumentu',
    doc_title: 'Název',
    doc_dims: 'Vlastní velikost',
    included_images: 'Vložené obrázky',
    image_opt_embed: 'Vkládat do dokumentu',
    image_opt_ref: 'Jen odkazem',
    editor_prefs: 'Nastavení editoru',
    language: 'Jazyk',
    background: 'Obrázek v pozadí editoru',
    editor_img_url: 'Image URL',
    editor_bg_note: 'Pozor: obrázek v pozadí nebude uložen jako součást dokumentu.',
    select_predefined: 'vybrat předdefinovaný:',
    units_and_rulers: 'Units & Rulers',
    show_rulers: 'Show rulers',
    base_unit: 'Base Unit:',
    grid: 'Grid',
    snapping_onoff: 'Snapping on/off',
    snapping_stepsize: 'Snapping Step-Size:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Nevhodná hodnota',
    noContentToFitTo: 'Vyberte oblast pro přizpůsobení',
    dupeLayerName: 'Taková vrstva už bohužel existuje',
    enterUniqueLayerName: 'Zadejte prosím jedinečné jméno pro vrstvu',
    enterNewLayerName: 'Zadejte prosím jméno pro novou vrstvu',
    layerHasThatName: 'Vrstva už se tak jmenuje',
    QmoveElemsToLayer: "Opravdu chcete přesunout vybrané objekty do vrstvy '%s'?",
    QwantToClear: 'Opravdu chcete smazat současný dokument?\nHistorie změn bude také smazána.',
    QwantToOpen: 'Do you want to open a new file?\nThis will also erase your undo history!',
    QerrorsRevertToSource: 'Chyba v parsování zdrojového kódu SVG.\nChcete se vrátit k původnímu?',
    QignoreSourceChanges: 'Opravdu chcete stornovat změny provedené v SVG kódu?',
    featNotSupported: 'Tato vlastnost ještě není k dispozici',
    enterNewImgURL: 'Vložte adresu URL, na které se nachází vkládaný obrázek',
    defsFailOnSave: 'POZOR: Kvůli nedokonalosti Vašeho prohlížeče se mohou některé části dokumentu špatně vykreslovat (mohou chybět barevné přechody nebo některé objekty). Po uložení dokumentu by se ale vše mělo zobrazovat správně.',
    loadingImage: 'Nahrávám obrázek ...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Mohou se vyskytnout následující problémy: ',
    unsavedChanges: 'There are unsaved changes.',
    enterNewLinkURL: 'Enter the new hyperlink URL',
    errorLoadingSVG: 'Error: Unable to load SVG data',
    URLLoadFail: 'Unable to load from URL',
    retrieving: "Retrieving '%s' ...",
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
